import { createContext, useContext } from 'react';

import {
  type RadioToggleGroupContextValue,
  type RadioToggleGroupItemContextValue,
} from './RadioToggleGroup.types';

export const RadioToggleGroupContext =
  createContext<RadioToggleGroupContextValue | null>(null);

export const RadioToggleGroupItemContext =
  createContext<RadioToggleGroupItemContextValue | null>(null);

export const useRadioToggleGroupContext = () => {
  const context = useContext(RadioToggleGroupContext);

  if (!context) {
    throw new Error(
      'useRadioToggleGroupContext must be used within a `<RadioToggleGroupContext.Provider />`',
    );
  }

  return context;
};

export const useRadioToggleGroupItemContext = () => {
  const context = useContext(RadioToggleGroupItemContext);

  if (!context) {
    throw new Error(
      'useRadioToggleGroupItemContext must be used within a `<RadioToggleGroupItemContext.Provider />`',
    );
  }

  return context;
};
